import { Condition } from "@redotech/redo-model/return-flow/condition";
import { PurchaseChannel } from "@redotech/redo-model/warranties";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const purchaseChannelToLabel: Record<PurchaseChannel, string> = {
  [PurchaseChannel.ONLINE]: "Online",
  [PurchaseChannel.RETAIL]: "Retail",
};

export interface PurchaseChannelState {
  channel: PurchaseChannel;
}

export const PURCHASE_CHANNEL = (
  Details: React.ComponentType<ConditionTypeDetailsProps<PurchaseChannelState>>,
): ConditionType<PurchaseChannelState, Condition.PurchaseChannel> => ({
  name: "Purchase Channel",
  description(state) {
    return `Purchase Channel: ${purchaseChannelToLabel[state.channel]}`;
  },
  Details(props: ConditionTypeDetailsProps<PurchaseChannelState>) {
    return React.createElement(Details, props);
  },
  empty: { channel: PurchaseChannel.ONLINE },
  fromModel(model) {
    return { channel: model.channel as PurchaseChannel };
  },
  toModel(state) {
    return {
      type: Condition.PURCHASE_CHANNEL,
      channel: state.channel as PurchaseChannel,
    };
  },
  valid(state) {
    return !!state.channel;
  },
});
